import React from 'react';
import PageProgress from '../PageProgress';

export default () => {
  return <PageProgress />;
};
